module.exports = __webpack_public_path__ + "img/img30.a41f17e8.jpg";